// extracted by css-extract-rspack-plugin
export default {"deleteButton":"gD43I"};